module.exports = __webpack_public_path__ + "img/coming-soon-img.7e6c177e.png";